/**
 * Class responsible for extracting object data from Messages.
 * 
 * @class MessageUtils
 * @type Message - Corresponds to the message object from Message Model received from the back-end.
 * @example
 * const locationInfo = MessageUtils.validateEmail(msgData: Message);
 * console.log(locationInfo); // { imageLocation: "", linkLocation: "", descriptionLocation: "" }
 */
class MessageUtils {
  static VCARDS_LIMITER = "\n----vcardLimiter----\n";

  /**
   * 
   * @param {Message} message - The message object to extract location info.
   * @returns {Object} The extracted location info object.
   */
  static extractLocationInfo(message) {
    const locationParts = message.body.split("|");

    return {
      imageLocation: locationParts[0]
      , linkLocation: locationParts[1]
      , descriptionLocation: locationParts[2] ?? null
    };
  };

  /**
   * 
   * @param {Message} message - The message object to extract button info.
   * @returns {Object} The extracted button info object.
   */
  static extractButtonInfo(message) {
    const buttonParts = message.body.split("##");
    const buttonArray = buttonParts[0].split("||");

    return {
      buttonTitle: buttonParts[1]
      , buttonFooter: buttonParts[2]
      , buttonBody: buttonArray[0]
      , buttonOptionsArray: buttonArray.slice(1)
    };
  }

  /**
   * 
   * @param {Message} message - The message object to extract list info,
   * @returns {Object} The extracted list info object.
   */
  static extractListInfo(message) {
    const listParts = message.body.split("||");
    const listHeader = listParts[0].split("%%");
    const listOptionsArray = listParts.slice(1);

    return {
      listTitle: listHeader[0]
      , listBody: listHeader[1]
      , listOption: listHeader[2]
      , listFooter: listHeader[3]
      , listOptionsArray: listOptionsArray
    };
  }

  /**
   * 
   * @param {Message} message - The message object to extract vcard info.
   * @returns {Object} The extracted vcard info object.
   */
  static extractVcardInfo(message) {
    const vcardParts = message.body ? message.body.split("\n") : message.split("\n");

    let contact = "";
    let number = "";

    for (const part of vcardParts) {
      let index = 0;

      const values = part.split(":");
      
      for (const value of values) {
        if (value.indexOf("waid=") !== -1 && number === "") number = value.split("waid=")[1];
        if (value.indexOf("FN") !== -1 && contact === "") contact = values[index + 1];
        index++;
      }
    }

    return { contact, number };
  }

  /**
   * 
   * @param {Message} message - The message object to extract multivcard info.
   * @returns {Object} The extracted multivcard info object.
   */
  static extractMultivcardInfo(message) {
    const vcardsArray = message.body.split(this.VCARDS_LIMITER).filter(vcard => vcard !== "");
    return { contactsList: vcardsArray.map(vcard => this.extractVcardInfo(vcard)) };
  }
}

export default MessageUtils;
